import { render, staticRenderFns } from "./rc-crm-edit-note-dialog.vue?vue&type=template&id=674c63cc&scoped=true&"
import script from "./rc-crm-edit-note-dialog.vue?vue&type=script&lang=js&"
export * from "./rc-crm-edit-note-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c63cc",
  null
  
)

export default component.exports